
















import Vue from 'vue'

type Data = {
  linkTitle: string | null;
  linkTo?: string;
};

export default Vue.extend({
  name: 'Error404',
  beforeRouteEnter (to, from, next) {
    const ignoreAuth = from.matched.every(record => !!record.meta.ignoreAuth)
    next(vm => {
      vm.$data.linkTitle = ignoreAuth ? 'アカウント登録に戻る' : 'ログインに戻る'
      if (ignoreAuth) {
        vm.$data.linkTo = '/signUp'
      }
    })
  },
  data (): Data {
    return {
      linkTitle: null,
      linkTo: undefined
    }
  },
  methods: {
    goTo (): void {
      this.$store.dispatch('logout', this.linkTo)
    }
  }
})
